export { default as List } from 'depreciations/containers/DepreciationsListContainer';
export { default as Form } from 'depreciations/containers/DepreciationsFormContainer';



// WEBPACK FOOTER //
// src/modules/secured/modules/depreciations/containers/index.js